import { MakeCall } from './createMakeCall';
import { RentalConditions } from './types/RentalConditions';

const getRentalConditionsById = (makeCall: MakeCall) => (id: number) =>
  makeCall<RentalConditions>(
    'GET',
    `/api/v2/bookings/rental-conditions/id/${id}`,
  );
export { getRentalConditionsById };
